import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { DialedDigitExtractionServer } from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: DialedDigitExtractionServer,
  originalDigitExtractionServerFormData: DialedDigitExtractionServer | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.DIALED_DIGIT_EXTRACTION_SERVER_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.DIALED_DIGIT_EXTRACTION_SERVER_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.msid,
    AuditService.DIALED_DIGIT_EXTRACTION_SERVER,
    actionType,
  );
  return auditDetails as AuditDetails;
}
